import { AccountEmployeeResolver } from '@account/account-employee.resolver';
import { AccountMenuService } from '@account/services';
import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FeatureFlag } from '@app/enums';
import { AbilityService, AnalyticService, AuthService, NotifyService } from '@app/services';
import { FeatureService } from '@app/services/feature.service';
import { ChangeRequestTemplateDisplayOptions } from '@app/types/translatables/change-request-template-display.options';
import { EmployeeChangeRequestTemplatesService } from '@employees/services';
import { PersonalShowView as EmployeePersonalShowView } from '@employees/views';

@Component({
    templateUrl: './personal-show.template.html',
    styleUrls: ['./personal-show.style.scss'],
})
export class PersonalShowView extends EmployeePersonalShowView implements OnInit {
    isSelfEmployeeView = true;
    showAddCustomFieldsButton = false;

    changeRequestTemplate = ChangeRequestTemplateDisplayOptions;

    constructor(
        public route: ActivatedRoute,
        public auth: AuthService,
        protected router: Router,
        protected abilities: AbilityService,
        protected notify: NotifyService,
        protected injector: Injector,
        public tabMenuService: AccountMenuService,
        protected analyticsService: AnalyticService,
        protected featureService: FeatureService,
        public changeRequestTemplateService: EmployeeChangeRequestTemplatesService
    ) {
        super(
            route,
            auth,
            changeRequestTemplateService,
            router,
            abilities,
            notify,
            injector,
            analyticsService,
            featureService
        );
    }

    async ngOnInit(): Promise<void> {
        this.showAddCustomFieldsButton = this.canUserManageCustomFields();

        const [hasChangeRequestFeatureFlag, shouldShowBirthdayVisibility, hasKYCKYBFeatureFlag] =
            await this.featureService.hasMany(
                FeatureFlag.changeRequests,
                FeatureFlag.birthdayVisibility,
                FeatureFlag.KYC_KYB
            );
        this.hasChangeRequestFeatureFlag = hasChangeRequestFeatureFlag;
        this.shouldShowBirthdayVisibility = shouldShowBirthdayVisibility;
        this.hasKYCKYBFeatureFlag.set(hasKYCKYBFeatureFlag);
        if (this.hasChangeRequestFeatureFlag) {
            this.changeRequestTemplates = await this.changeRequestTemplateService.getActiveTemplates();
            this.canCreateChangeRequest =
                this.changeRequestTemplateService.canRequestForEmployee(this.employee) &&
                this.changeRequestTemplates.length > 0;
        }
        this.isLoading = false;
    }

    openEditBasicInfoDialog(): void {
        this.editFormBasicInformationForm.beforeShow();
        this.currentlyOpenDialog = 'BASIC_INFO';
    }

    protected setResolver(): void {
        this.resolver = this.injector.get(AccountEmployeeResolver);
    }
}
